module.exports = __webpack_public_path__ + "static/media/icon-calendar.af91aa4e.svg";